import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class GroupsService {
  constructor(private apiService: ApiService) {}

  getList() {
    return this.apiService.request('/groups', 'GET');
  }

  create(group: any) {
    return this.apiService.request('/groups/create', 'POST', group);
  }

  update(group: any) {
    return this.apiService.request('/groups/update', 'POST', { group });
  }

  get(groupId: string) {
    return this.apiService.request(`/groups/${groupId}`, 'GET');
  }

  createPost(groupId: string, message: string) {
    return this.apiService.request(`/groups/${groupId}/posts`, 'POST', {
      message,
    });
  }
}
